import { combineReducers } from 'redux';

import account from 'js/src/data/account';
import aiVoicesAndAvatars from 'js/src/data/ai-voices-and-avatars';
import blueprints from 'js/src/data/blueprints';
import comments from 'js/src/data/comments';
import mediaRecommendationPreferencesReducer from 'js/src/data/media-recommendation-preferences/media-recommendation-preferences-slice';
import modals from 'js/src/data/modals';
import notifications from 'js/src/data/notifications';
import shareVideo from 'js/src/data/share-video';
import templates from 'js/src/data/templates';
import thumbnailPreviews from 'js/src/data/thumbnail-previews';
import { transcript } from 'js/src/data/transcript';
import translations from 'js/src/data/translations';
import { videoPlannerReducer as videoPlanner } from 'js/src/data/video-planner';
import { undoable } from 'js/src/entry-points/root-reducers/reducers/undoable';

export const getRootReducer = () => {
    return combineReducers({
        account,
        modals,
        shareVideo,
        comments,
        translations,
        notifications,

        // spinoffs video plan reducers
        templates,
        videoPlanner,
        mediaRecommendationPreferences: mediaRecommendationPreferencesReducer,
        thumbnailPreviews,
        aiVoicesAndAvatars,
        transcript,
        undoable,
        blueprints,
    });
};
